/* Text animation */
(function () {
  let ticking = false;

  function revealOnScroll() {
    const elements = document.querySelectorAll(".reveal, [id$='__section_QChnef']");

    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight * 0.9 && rect.bottom > 0) {
        el.classList.add("is-visible");
      } else {
        el.classList.remove("is-visible");
      }
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        revealOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  // init
  document.addEventListener("DOMContentLoaded", revealOnScroll);
  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", revealOnScroll);
  document.addEventListener("shopify:section:load", revealOnScroll);
})();